// extracted by mini-css-extract-plugin
module.exports = {"navabar":"navbar_navabar__2xuiD","content":"navbar_content__gBhZT","row":"navbar_row__cKmgg","desc":"navbar_desc__m9OG_","login":"navbar_login__WdKNM"};